import { DEFAULT_COLUMN_WIDTH } from '@/constants/tables';

// 100 is a hack
// it is needed to flex-grow works properly
export const getColumnWidth = (isFixedWidth, width) => (isFixedWidth ? width || DEFAULT_COLUMN_WIDTH : 100);
